import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { UserType } from '../../types';
import { DataChannelMessageType, DataChannelSessionIntentionEditedMessage, useSendMessage } from '../../video-sdk';
import { providerShortIdAtom } from '../state';

export function useSendSessionIntentionEditedCallback() {
  const getProviderShortId = useAtomCallback(useCallback((get) => get(providerShortIdAtom), []));
  const sendMessage = useSendMessage();

  return useCallback(
    async (shortId: string) => {
      const editedAt = new Date().toISOString();
      const message: DataChannelSessionIntentionEditedMessage = {
        type: DataChannelMessageType.SESSION_INTENTION_EDITED,
        sender: {
          entityId: getProviderShortId() ?? '',
          entityType: UserType.PROVIDER,
        },
        sessionIntention: {
          shortId,
          editedAt,
        },
      };

      const didSendMessage = await sendMessage(message);

      return didSendMessage;
    },
    [sendMessage, getProviderShortId],
  );
}
